import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { __rest } from "tslib";
import React from "react";
import TabLabel from "../TabLabel";
import TabPanel from "../TabPanel";
var Tab = function Tab(_a) {
  var children = _a.children,
    rest = __rest(_a, ["children"]);
  var _React$Children$toArr = React.Children.toArray(children).filter(function (child) {
      if (child.type === TabLabel) {
        return child;
      }
      return /*#__PURE__*/React.createElement(React.Fragment, null);
    }),
    _React$Children$toArr2 = _slicedToArray(_React$Children$toArr, 1),
    tabLabel = _React$Children$toArr2[0];
  var tabLabelWithProps = /*#__PURE__*/React.cloneElement(tabLabel, Object.assign({}, rest));
  return /*#__PURE__*/React.createElement(React.Fragment, null, tabLabelWithProps);
};
Tab.Label = TabLabel;
Tab.Panel = TabPanel;
export default Tab;